import { jsx as _jsx } from "react/jsx-runtime";
import { MultiSelect } from '@bos/ui';
import { useController } from 'react-hook-form';
export const MultiSelectField = ({ control, name, registerOptions, ...multiSelectProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        ...registerOptions,
    });
    const handleValueChange = (value) => field.onChange(value);
    const currentValue = field.value ?? [];
    return (_jsx(MultiSelect, { ...multiSelectProps, value: currentValue, error: fieldState.error?.message, withIndicator: true, onValueChange: handleValueChange }));
};
